// extracted by mini-css-extract-plugin
export default {"wrapper":"TimeOffPolicies_wrapper__pd-p8","controls":"TimeOffPolicies_controls__d22S8","searchWrapper":"TimeOffPolicies_searchWrapper__DODUR"};